/** @jsxImportSource @emotion/react */
import { Box, css } from '@mui/material'

export const CenteredBox: React.FC<{ children: React.ReactNode; height?: number }> = ({
  children,
  height,
}) => <Box css={centeredBoxStyles(height)}>{children}</Box>

export const centeredBoxStyles = (height?: number) => css`
  height: ${height ? `${height}px` : '100%'};
  display: flex;
  align-items: center;
  justify-content: center;
`
